import styled from 'styled-components';

export const InpuTypeDate = styled.input`
  background-color: transparent;
  border: 1px solid;
  border-color: #ccc;
  box-sizing: border-box;
  height: 2.5rem;
  padding: 5px;
  color: inherit;
  cursor: inherit;
  font-size: 14px;
  min-width: 0;
  width: 100%;
  line-height: 1.4285714285714286;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-bottom: 8px;
`;

export const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const FilterTitle = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;

  &:hover {
    color: #d32f2f;
    background-color: #f5f5f5;
    border-radius: 4px;
  }
`;

export const ConditionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ConditionDropdown = styled.select`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  cursor: pointer;
  min-width: 150px;

  &:focus {
    outline: none;
    border-color: #0052cc;
    box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.2);
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
`;

export const DateInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  /* Primeiro filho (div que contém o Macro ou input) deve ocupar todo o espaço disponível */
  > div:first-child {
    flex: 1;
    width: 100%;
  }
`;

export const DateInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  color: #666;
  padding: 0px;
  margin-bottom: 8px;
  height: 40px !important;

  &:hover {
    background-color: #f5f5f5;
    border-color: #999;
  }
`;

export const ErrorMessage = styled.div`
  color: #d32f2f;
  font-size: 12px;
  margin-top: 4px;
`;

export const FullWidthButton = styled.div`
  width: 100%;

  > button {
    width: 100%;
  }
`;

export const BetweenLabel = styled.div`
  text-align: center;
  font-size: 14px;
  color: #666;
  margin: 8px 0;
  font-weight: 500;
`;
